"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["direction"];
var DIRECTIONS = {
  up: -90,
  right: 0,
  down: 90,
  left: 180
};

var withDirection = function withDirection(Icon) {
  var RotatedIcon = function RotatedIcon(_ref) {
    var direction = _ref.direction,
        props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(Icon, (0, _extends2["default"])({
      style: {
        transform: "rotate(".concat(DIRECTIONS[direction], "deg)")
      }
    }, props));
  };

  RotatedIcon.propTypes = {
    direction: _propTypes["default"].oneOf(Object.keys(DIRECTIONS))
  };
  RotatedIcon.defaultProps = {
    direction: 'right'
  };
  RotatedIcon.isIcon = true;
  return RotatedIcon;
};

var _default = withDirection;
exports["default"] = _default;